"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_VISIBILITY_TODAY = void 0;
const patient_permissions_1 = require("../permissions/patient.permissions");
const appointment_permissions_1 = require("../permissions/appointment.permissions");
const clinical_permissions_1 = require("../permissions/clinical.permissions");
const master_data_permissions_1 = require("../permissions/master-data.permissions");
exports.MODULE_VISIBILITY_TODAY = [
    { moduleCode: 'DASHBOARD', alwaysVisibleToday: true },
    // Has COMING_SOON leaves (fo-token, fo-ip-admission, fo-insurance-verification, fo-visitor-management).
    { moduleCode: 'FRONT_OFFICE', alwaysVisibleToday: true },
    // Has COMING_SOON leaves via its 'clinical-ipd' child subtree.
    { moduleCode: 'CLINICAL', alwaysVisibleToday: true },
    // 'clinical-opd' subtree is 100% real pages — the one genuine gate besides Pharmacy.
    {
        moduleCode: 'CLINICAL_OPD',
        alwaysVisibleToday: false,
        requiresAnyOf: [
            clinical_permissions_1.ClinicalPermissions.CLINICAL_VIEW,
            clinical_permissions_1.ClinicalPermissions.CLINICAL_CREATE,
            clinical_permissions_1.ClinicalPermissions.CLINICAL_ORDER_CREATE,
        ],
    },
    // 100% COMING_SOON subtree.
    { moduleCode: 'CLINICAL_IPD', alwaysVisibleToday: true },
    // Added 2026-10-23 with the Discharge module. It did not exist when the module layer went live, so nothing "already
    // sees" it today: no role gets it from the backfill (`alwaysVisibleToday: false` with no permission that maps to it
    // would grant none); it is granted deliberately, in Administration → Roles → Modules or by `provision-discharge-roles.ts`.
    { moduleCode: 'DISCHARGE', alwaysVisibleToday: false, requiresAnyOf: [] },
    // Added 2026-11-02 with the MRD module. Like Discharge it did not exist when the module layer went live, so no role gets it from
    // the backfill; it is granted deliberately (Administration → Roles → Modules, or `provision-mrd-roles.ts`).
    { moduleCode: 'MRD', alwaysVisibleToday: false, requiresAnyOf: [] },
    // Has COMING_SOON leaf (diagnostics-blood-bank).
    { moduleCode: 'DIAGNOSTICS', alwaysVisibleToday: true },
    // 100% COMING_SOON subtree.
    { moduleCode: 'LABORATORY', alwaysVisibleToday: true },
    // 100% COMING_SOON subtree.
    { moduleCode: 'RADIOLOGY', alwaysVisibleToday: true },
    // The ONE top-level group with a real group-level `requires` today — genuinely gated, no leak.
    { moduleCode: 'PHARMACY', alwaysVisibleToday: false, requiresAnyOf: [master_data_permissions_1.MasterDataPermissions.DRUG_MASTER_READ] },
    // Has COMING_SOON leaves (bf-profit-loss, bf-balance-sheet) plus its 'bf-billing' child's own leak.
    { moduleCode: 'BILLING_FINANCE', alwaysVisibleToday: true },
    // Has COMING_SOON leaves (billing-ip, billing-lab, billing-radiology).
    { moduleCode: 'BILLING', alwaysVisibleToday: true },
    // 100% COMING_SOON subtree.
    { moduleCode: 'INSURANCE', alwaysVisibleToday: true },
    // 100% COMING_SOON subtree.
    { moduleCode: 'MATERIALS', alwaysVisibleToday: true },
    // 100% COMING_SOON subtree.
    { moduleCode: 'HR', alwaysVisibleToday: true },
    // Has COMING_SOON leaves (rep-executive, rep-clinical, rep-laboratory, rep-insurance, rep-operational, rep-custom).
    { moduleCode: 'REPORTS', alwaysVisibleToday: true },
    // Has COMING_SOON leaves (admin-printers, admin-barcode, admin-notifications, admin-integrations, admin-backup) —
    // this is exactly why user1 (Pharmacy-only role) sees "Administration" today.
    { moduleCode: 'ADMINISTRATION', alwaysVisibleToday: true },
];
// Referenced so `AppointmentPermissions`/`PatientPermissions` imports stay
// intentional (front-office's real leaves use them) even though
// FRONT_OFFICE's own rule above is alwaysVisibleToday due to its
// COMING_SOON siblings — kept for when that leak is eventually cleaned up
// and this file needs a real requiresAnyOf for FRONT_OFFICE instead.
void patient_permissions_1.PatientPermissions;
void appointment_permissions_1.AppointmentPermissions;
//# sourceMappingURL=module-leaf-requirements.js.map